"use strict";

module.exports = function (page) {
  if (this.vuex) return;
  this.setPage(page);
  this.dispatch('pagination', page);
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/methods/on-pagination.js
// module id = aL0I
// module chunks = 0